"use client";

import { Sprout } from "lucide-react";

export default function Loading() {
  const brandName = "ZAMZI CONNECT";
  const colors = [
    "#4285F4", // Google Blue
    "#DB4437", // Google Red
    "#F4B400", // Google Yellow
    "#0F9D58", // Google Green
    "#4285F4",
    "#DB4437",
    "#F4B400",
    "#0F9D58",
    "#4285F4",
    "#DB4437",
    "#F4B400",
    "#0F9D58",
    "#4285F4",
    "#DB4437",
  ];

  return (
    <div className="fixed inset-0 z-200 flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center justify-center space-y-4">
        {/* Bouncing Sprout Icon */}
        <div className="animate-bounce">
          <Sprout className="h-16 w-16 text-green-600" />
        </div>

        {/* Bouncing, multi-colored text */}
        <div className="flex items-center justify-center animate-pulse">
          {brandName.split("").map((char, index) => (
            <span
              key={index}
              className="text-2xl font-bold"
              style={{
                color: char === " " ? "transparent" : colors[index % colors.length],
                // Apply a subtle bounce animation to each letter with a delay
                animation: `bounce-letter 1.5s infinite ${index * 0.05}s`,
              }}
            >
              {char}
            </span>
          ))}
        </div>
      </div>
      <div className="animate-bounce-letter">Loading...</div>
    </div>
  );
}
